import { render, staticRenderFns } from "./DisplaySimple.vue?vue&type=template&id=4eb079c0&scoped=true&"
import script from "./DisplaySimple.vue?vue&type=script&lang=js&"
export * from "./DisplaySimple.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySimple.vue?vue&type=style&index=0&id=4eb079c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb079c0",
  null
  
)

component.options.__file = "DisplaySimple.vue"
export default component.exports